<template>
    <div>
        <div class="courses">
            <section class="form-section">
                <div class="form-section-heading">
                    {{
                        trans('clients.transfer_course.headline.select_courses')
                    }}
                </div>
                <div class="form-row">
                    <div class="form-row__col form-row__col--one-half">
                        <label class="label">
                            {{
                                trans(
                                    'clients.transfer_course.label.select_source'
                                )
                            }}
                        </label>
                        <v-select
                            v-model="selectedCoursesSource"
                            :options="courseList"
                            class="form-vue-select"
                            multiple
                            @change="clearLists"
                        >
                            <div slot="no-options">
                                {{ trans('vue_select.no_options') }}
                            </div>
                        </v-select>
                    </div>

                    <div class="form-row__col form-row__col--one-half">
                        <label class="label">
                            {{
                                trans(
                                    'clients.transfer_course.label.select_target'
                                )
                            }}
                        </label>
                        <v-select
                            v-model="selectedCourseTarget"
                            :options="courseList"
                            class="form-vue-select"
                            @change="clearLists"
                        >
                            <div slot="no-options">
                                {{ trans('vue_select.no_options') }}
                            </div>
                        </v-select>
                    </div>
                </div>
            </section>

            <section class="form-section">
                <div class="form-section-heading">
                    {{ trans('clients.transfer_course.headline.select_users') }}
                </div>

                <v-client-table
                    :data="selectedUsers"
                    :columns="columns"
                    :options="options"
                    ref="table"
                >
                    <div
                        @click="removeUser(props.row.id)"
                        slot="removeUser"
                        slot-scope="props"
                        class="btn btn--tertiary"
                    >
                        {{ trans('clients.transfer_course.action.remove') }}
                    </div>
                </v-client-table>
            </section>
        </div>

        <div class="page-control">
            <div class="page-control__element">
                <div
                    @click="openModal"
                    :disabled="disableModalButton"
                    class="btn btn--big btn--tertiary"
                >
                    {{ trans('clients.transfer_course.action.open_modal') }}
                </div>
            </div>
            <div class="page-control__element">
                <button
                    class="btn btn--big btn--primary"
                    :disabled="disableSaveButton"
                    @click="submit()"
                >
                    <!-- disable if not all cards have coursevariation selected -->
                    {{ trans('buttons.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ClientTransferCourseModal from './ClientTransferCourseModal';
import { EventBus } from '../eventbus.js';

export default {
    props: ['client', 'courseList'],

    data() {
        return {
            selectedCoursesSource: [],
            selectedCourseTarget: null,
            selectedUsers: [],
            modalUserList: [],
            validationErrors: {},
            showAddButton: true,
            columns: ['fullname', 'username', 'email', 'removeUser'],
            options: {
                headings: {
                    fullname: this.trans(
                        'clients.transfer_course.label.fullname'
                    ),
                    username: this.trans(
                        'clients.transfer_course.label.username'
                    ),
                    email: this.trans('clients.transfer_course.label.email'),
                    removeUser: '',
                },
                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.noResults'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },
                sortable: [],
            },
        };
    },

    computed: {
        selectedUsersIdArray() {
            return this.selectedUsers.length
                ? this.selectedUsers.map(u => u.id)
                : [];
        },
        filteredModalUserList() {
            return this.modalUserList.filter(
                u => !this.selectedUsersIdArray.includes(u.id)
            );
        },
        disableSaveButton() {
            return !this.selectedUsers.length;
        },
        disableModalButton() {
            return (
                !this.selectedCourseTarget || !this.selectedCoursesSource.length
            );
        },
    },

    methods: {
        openModal() {
            // get users first if necessary or directly open modal
            if (!this.modalUserList.length) {
                this.getUsers();
            } else {
                this.showModal();
            }
        },
        getUsers() {
            axios
                .post(
                    this.route('tenantapi.clients.transfer_course.get_users', {
                        client: this.client.id,
                    }),
                    {
                        sourceIds: this.selectedCoursesSource.map(c => c.value),
                        targetId: this.selectedCourseTarget.value,
                    }
                )
                .then(response => {
                    this.modalUserList = response.data.users;
                    this.showModal();
                });
        },
        showModal() {
            this.$modal.show(
                ClientTransferCourseModal,
                {
                    'user-list': this.filteredModalUserList,
                },
                {
                    height: 'auto',
                    width: '80%',
                    adaptive: true,
                    pivotY: 0.3,
                    scrollable: true,
                }
            );
        },
        removeUser(id) {
            this.$delete(
                this.selectedUsers,
                this.selectedUsers.findIndex(u => u.id == id)
            );
        },
        clearLists() {
            this.selectedUsers = [];
            this.modalUserList = [];
        },
        submit() {
            axios({
                method: 'post',
                url: this.route('tenant.clients.transfer_course.store', {
                    client: this.client.id,
                }),
                data: {
                    courseSource: this.selectedCoursesSource,
                    courseTarget: this.selectedCourseTarget,
                    users: this.selectedUsers.map(u => u.id),
                },
            }).then(response => {
                // hack TODO: unhack it
                const link = document.createElement('a');
                link.href = response.data;
                document.body.appendChild(link);
                link.click();
            });
        },
    },

    mounted() {
        EventBus.$on('user-selected', id => {
            this.selectedUsers.push(this.modalUserList.find(u => u.id == id));
        });
    },
};
</script>
